import {useQueryClient} from "@tanstack/react-query";
import { USER_CURRENT_KEY } from "../api/public-voissa/users";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ModalContext } from "../ui/components2/ModalManager";
import createLink from "../libs/createLink";
import { useFiltersLocal } from "./useFiltersLocal";

export const MEDIA_LOCKED_LABEL = {
    BIG_PLAN : 'BIG_PLAN',
    FRIENDS : 'FRIENDS',
    CERTIFIED : 'CERTIFIED',
    MEMBERS_ONLY : 'MEMBERS_ONLY',
    INVISIBLE : 'INVISIBLE',
    VIDEO_NOT_READY : 'VIDEO_NOT_READY',
    VIDEO_ERROR_STATE : 'VIDEO_ERROR_STATE'
}

const useMediaLocked = (media)=>{
    const navigate = useNavigate();
    const { openModal } = useContext(ModalContext);
    const {getFilter, setFilter} = useFiltersLocal();
    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    let lockedReason = null;
    let locked = false;
    if(!(currentUser?._id === media.owner._id)){
        const isBigPlan = (media.kind !== "video" && media.contentReview === 4 && getFilter('bigPlanLocked', true)) ? MEDIA_LOCKED_LABEL.BIG_PLAN : null;
        const isFriendOnly = (media.right === "friends" && media.previewUrl.includes('encrypted')) ? MEDIA_LOCKED_LABEL.FRIENDS : null;
        const isCertifiedOnly = (media.right === "certified" && media.previewUrl.includes('encrypted')) ? MEDIA_LOCKED_LABEL.CERTIFIED : null;
        const isMembersOnly = (!currentUser && media.right !== "guest" && !isFriendOnly) ? MEDIA_LOCKED_LABEL.MEMBERS_ONLY : null;
        const isInvisible = (media.display === false) ? MEDIA_LOCKED_LABEL.INVISIBLE : null;
        const isVideoNotReady = (media.kind === "video" &&  media.state !== 1) ? MEDIA_LOCKED_LABEL.VIDEO_NOT_READY : null;
        lockedReason = isInvisible || isFriendOnly || isMembersOnly || isCertifiedOnly || isVideoNotReady || isBigPlan;
        locked = !!lockedReason;
    }
    else {
        const isVideoErrorState = (media.kind === "video" &&  media.state === 3) ? MEDIA_LOCKED_LABEL.VIDEO_ERROR_STATE : null;
        lockedReason = isVideoErrorState;
    }
    const handleLockedAction = ()=>{
        if(!lockedReason) return false;
        switch (lockedReason) {
            case MEDIA_LOCKED_LABEL.FRIENDS:
                !!currentUser ? openModal('AlertModal', {title : "Vous ne faites pas parti(e) de son cercle.", description : "Pour accéder à cette collection vous devez suivre son profil et attendre d'être ajouté(e) à son cercle. "}) : navigate(createLink("signin"));
                break;
            case MEDIA_LOCKED_LABEL.CERTIFIED:
                !!currentUser ? navigate(createLink("userMeSettingsAbonnement")) : openModal('Signup', {lockedContentOwner : media.owner, lockedReason :  MEDIA_LOCKED_LABEL.MEMBERS_ONLY, lockedAction : 'VIEW_PUBLICATION'});
                break;
            case MEDIA_LOCKED_LABEL.MEMBERS_ONLY:
                openModal('Signup', {lockedContentOwner : media.owner, lockedReason :  MEDIA_LOCKED_LABEL.MEMBERS_ONLY, lockedAction : 'VIEW_PUBLICATION'});
                break;
            case MEDIA_LOCKED_LABEL.BIG_PLAN:
                setFilter('bigPlanLocked', false);
                break;
            default:
                console.error('No action provided for this locked content');
                return false;
        }
        return true;
    }
    return {locked, lockedReason, handleLockedAction};
}

export default useMediaLocked;